const config1 = [
    {
        placeholder: 'All Teams',
        name: 'all-teams',
        type: 'multiple-select',
        options: [
            {value: 'all', label: 'All Competitions Played'},
            {value: 'strawberry', label: 'Strawberry'},
            {value: 'vanilla', label: 'Vanilla'},
        ],
        withSearch: true,
        span: {xs: 12, md: 6, lg: 2},
    },
    {
        placeholder: 'All Countries',
        name: 'all-countries',
        type: 'multiple-select',
        options: [
            {value: 'all', label: 'All Competitions Played'},
            {value: 'strawberry', label: 'Strawberry'},
            {value: 'vanilla', label: 'Vanilla'},
        ],
        withSearch: true,
        span: {xs: 12, md: 6, lg: 2},
    },
    {
        placeholder: 'All Regions',
        name: 'all-regions',
        type: 'multiple-select',
        options: [
            {value: 'all', label: 'All Competitions Played'},
            {value: 'strawberry', label: 'Strawberry'},
            {value: 'vanilla', label: 'Vanilla'},
        ],
        withSearch: true,
        span: {xs: 12, md: 6, lg: 2},
    },
    {
        placeholder: 'Search Player, Team, Country, Position...etc',
        name: 'search',
        type: 'search',
        align: 'right',
        span: {xs: 12, md: 6, lg: 3},
    },
];

export {
    config1 as Scouting,
}
